import { useEffect, useState } from "react"

const STATUS_INTERVAL_MS = 2500

export const useRotatingMessage = (messages: string[], isActive: boolean): string => {
  const [messageIndex, setMessageIndex] = useState(0)

  useEffect(() => {
    if (!isActive) {
      setMessageIndex(0)
      return
    }
    const interval = setInterval(() => setMessageIndex((index) => (index + 1) % messages.length), STATUS_INTERVAL_MS)
    return () => clearInterval(interval)
  }, [messages, isActive])

  return messages[messageIndex]
}
